import { create_div } from 'js/utils';

import './login_page.scss';

const settings = login_page_settings;

function init(){
    
    add_placeholders();
    render_bg();
    render_logo();
    group_bottom_elements();
    customize_submit_button();
    customize_lost_password_link();

    if( settings.type === 'form_left' ) {
        import('./form_left');
    }
    else {
        import('./form_center');
    }
}
init();

function add_placeholders(){
    const user_login = document.getElementById('user_login');
    if( user_login ) {
        user_login.placeholder = 'Username or Email Address';
    }
    const user_pass = document.getElementById('user_pass');
    if( user_pass ) {
        user_pass.placeholder = 'Password';
    }
}

function render_bg(){
    if( !settings.bg_image ) return;

    const selector = settings.type === 'form_left' ? '.custom_bg' : 'body';
    const el = document.querySelector(selector);
    if( !el ) return;

    el.style.backgroundImage = 'url('+settings.bg_image+')';
}

function render_logo(){
    if( !settings.logo ) return;

    const container = document.getElementById('loginform');
    if( !container ) return;
    
    const logo_container = create_div('custom_logo');
    container.prepend(logo_container);

    const logo = document.createElement('img');
    logo.src = settings.logo;
    logo_container.append(logo)
}

function group_bottom_elements(){

    const checkbox = document.querySelector('.forgetmenot');
    if( !checkbox ) return;

    const submit_btn = document.querySelector('#loginform .submit');

    const con = create_div('form_bottom_elements');
    con.id = 'form_bottom_elements';

    checkbox.before(con);
    con.append(checkbox);
    con.append(submit_btn);
}

function customize_submit_button(){
    const submit_btn = document.querySelector('#wp-submit');
    submit_btn.value = 'Login';
}

function customize_lost_password_link(){
    const el = document.querySelector('.wp-login-lost-password');
    if( !el ) return;
    el.innerHTML = 'Forgot your password? <span>Reset Password</span>';
}